<template>
  <el-dialog
    :title="dialog.title"
    width="520px"
    :visible.sync="dialog.isShow"
    @close='closeDialog'
    @open='openDialog'
  >
    <el-form
      ref="ruleForm"
      :model="form"
      label-width="80px"
      class="dr-form"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="名称"
            prop="name"
          >
          <el-input v-model="name" readonly placeholder="名称">
            <el-button v-if="dialog.type==0" slot="append" icon="el-icon-search" @click="selectProductHandle"></el-button>
            <el-button v-if="dialog.type==1" slot="append" icon="el-icon-search" @click="selectMeasuredHandle"></el-button>
            <el-button v-if="dialog.type==2" slot="append" icon="el-icon-search" @click="selectStoreHandle"></el-button>
            <el-button v-if="dialog.type==3" slot="append" icon="el-icon-search" @click="selectFlashSaleHandle"></el-button>
          </el-input> 
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="奖励"
            prop="reward"
          >
          <el-input v-model="form.reward" placeholder="奖励百分比">
            <el-button slot="append" >%</el-button>
          </el-input>   
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dr-dialog-footer"
    >
      <el-button @click="dialog.isShow = false">
        关 闭
      </el-button>
      <el-button
        type="primary"
        @click="Save"
      >
       保 存
      </el-button>
    </div>
    <GetChainStore v-bind:dialogStore="dialogStore" @UpdateSote="UpdateSote"></GetChainStore>
    <GetProduct v-bind:dialogProduct="dialogProduct" @UpdateProduct="UpdateProduct"></GetProduct>    
    <GetMeasuredService v-bind:dialogMeasuredService="dialogMeasuredService" @UpdateMeasuredService="UpdateMeasuredService"></GetMeasuredService>    
    <GetFlashSale v-bind:dialogFlashSale="dialogFlashSale" @UpdateFlashSale="UpdateFlashSale"></GetFlashSale>
  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
  import GetChainStore from '@/components/GetChainStore'
  import GetProduct from '@/components/GetProduct'
  import GetMeasuredService from '@/components/GetMeasuredService'
  import GetFlashSale from '@/components/GetFlashSale'
  import { Loading } from 'element-ui';
  export default {
    props:{
      dialog:{}
    },
    data(){
      return {
        loading:false,
        form:{
          id:0,
          reward:0,
          itemId:0,
          type:0
        },
        name:'',
        dialogStore:{
          isShow:false
        },
        dialogProduct:{
          isShow:false
        },
        dialogMeasuredService:{
          isShow:false
        },
        dialogFlashSale:{
          isShow:false
        },
      }
    },
    mounted(){
      
    },
    components:{    
      GetChainStore,
      GetProduct,
      GetMeasuredService,
      GetFlashSale
    },
    methods:{
      GetData:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/ShareSale/Get',
          data:{
            id: that.dialog.id
          }
        }).then(function (resp) {
          debugger
          that.form = resp.data.result.data
          that.name = resp.data.result.name
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleCancel:function(){

      },
      selectProductHandle:function(){        
        console.log("selectProductHandle ")
        this.dialogProduct.isShow = true
      },
      UpdateProduct:function(id,name){
        this.form.itemId = id 
        this.name = name
      },
      selectMeasuredHandle:function(){
        this.dialogMeasuredService.isShow = true
      },
      UpdateMeasuredService:function(id,name){
        this.form.itemId = id 
        this.name = name
      },
      selectStoreHandle:function(){
        this.dialogStore.isShow = true
      },   
      UpdateSote:function(id,name){
        this.form.itemId = id 
        this.name = name 
      },  
      selectFlashSaleHandle:function(){
        this.dialogFlashSale.isShow = true
      }, 
      UpdateFlashSale:function(id,name){
        this.form.itemId = id 
        this.name = name
      },
      closeDialog:function(){
        this.dialogStoreIsShow = false
        this.dialogProduct.isShow = false
      },
      openDialog:function(){
        this.name = ''
        if(this.dialog.id!=0)
          this.GetData()      
        else 
          this.form.type = this.dialog.type
      },
      Save:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/ShareSale/Save',         
          data:this.form
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    }
   }
</script>
